import React from 'react';
import { Badge, Tooltip } from '@chakra-ui/react';

const STATUS_COLOR = {
    computed: 'green',
    inferred: 'yellow',
    unavailable: 'red',
};

const STATUS_HELP = {
    computed: 'This KPI is computed directly from tenant data uploaded into the platform.',
    inferred: 'This KPI is approximated from related signals because the canonical dataset is not yet loaded.',
    unavailable: 'The dataset required to compute this KPI is missing. Upload the matching firm-ready file to enable it.',
};

const KpiProvenanceTag = ({ status = 'computed', label, ...rest }) => {
    const normalized = STATUS_COLOR[status] ? status : 'computed';
    return (
        <Tooltip label={STATUS_HELP[normalized]} hasArrow placement="top">
            <Badge
                colorScheme={STATUS_COLOR[normalized]}
                borderRadius="full"
                px={2}
                fontSize="0.6rem"
                textTransform="uppercase"
                {...rest}
            >
                {label || normalized}
            </Badge>
        </Tooltip>
    );
};

export default KpiProvenanceTag;
